import { render, staticRenderFns } from "./Buy.vue?vue&type=template&id=13c6e95e&scoped=true&"
import script from "./Buy.vue?vue&type=script&lang=js&"
export * from "./Buy.vue?vue&type=script&lang=js&"
import style0 from "./Buy.vue?vue&type=style&index=0&id=13c6e95e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6e95e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c6e95e')) {
      api.createRecord('13c6e95e', component.options)
    } else {
      api.reload('13c6e95e', component.options)
    }
    module.hot.accept("./Buy.vue?vue&type=template&id=13c6e95e&scoped=true&", function () {
      api.rerender('13c6e95e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/views/Buy.vue"
export default component.exports